import { Box } from '@mui/system';
import { StyledCommunixBundle } from './style';
import { BundleProps } from '../types';
import BundlePrice from '../BundlePrice';
import {
    EBadgePosition,
    EBadgeType,
    EBundlesInternalViewModel
} from '../../Helper/enums';
import { RibbonBadge } from '../../Badge/RibbonBadge/RibbonBadge';
import { useEffect, useState } from 'react';
import { BadgeData, EBadgeDesignType } from '../../Badge/types';
import { DefaultSaleBadge } from '../../Badge/Sale/DefaultSaleBadge';
import { generateSalePercentageBasedOnType } from '../../../utils';

function Bundle({
    price,
    fontFamily,
    productList,
    badges = [],
    backgroundSrc,
    backgroundColor = { colorOne: '#880000' },
    bundleBorderColor,
    bundleButtonColor,
    bundleButtonTextColor,
    salePercentage = 0,
    borderRadius,
    salePercentageDisplayType,
    inMobileMock = false
}: BundleProps) {
    const [ribbonBadge, setRibbonBadge] = useState<any>(null);

    useEffect(() => {
        let foundRibbon;
        if (badges.length > 0) {
            if (badges[0].badge) {
                foundRibbon = badges?.find(
                    (badge: BadgeData) =>
                        (badge as BadgeData).badge?.type === EBadgeType.RIBBON
                )?.badge as BadgeData;
                setRibbonBadge(foundRibbon?.ribbon);
            } else {
                foundRibbon = badges?.find(
                    (badge: BadgeData) => badge.type === EBadgeType.RIBBON
                );
                setRibbonBadge(foundRibbon?.ribbon);
            }
        }
    }, [badges]);

    return (
        <StyledCommunixBundle
            fontFamily={fontFamily}
            direction={price.symbolPosition === 'Right' ? 'rtl' : 'ltr'}
            marginRight={
                price.spacing && price.symbolPosition === 'Left' ? '4px' : '0px'
            }
            marginLeft={
                price.spacing && price.symbolPosition === 'Right'
                    ? '4px'
                    : '0px'
            }
            productColor={
                productList.length > 0 ? productList[0].textFontColorHex : ''
            }
            bundleButtonColor={bundleButtonColor}
            bundleBorderColor={bundleBorderColor}
            backgroundSrc={backgroundSrc}
            backgroundColor={backgroundColor}
            className="internal-bundle"
            isSale={!!salePercentage}
            borderRadius={borderRadius}
        >
            <Box className="container">
                <Box className="product">
                    {productList.length > 0 && (
                        <>
                            {salePercentage > 0 && (
                                <Box className="badge-wrapper">
                                    <DefaultSaleBadge
                                        salePercentage={salePercentage}
                                        position={EBadgePosition.TOP}
                                        text={`${generateSalePercentageBasedOnType(
                                            salePercentage,
                                            salePercentageDisplayType
                                        )} MORE`}
                                        designType={EBadgeDesignType.MIDDLE}
                                        salePercentageDisplayType={
                                            salePercentageDisplayType
                                        }
                                    />
                                </Box>
                            )}
                            <Box className="amount">
                                <Box
                                    sx={{
                                        lineHeight: '90%'
                                    }}
                                >
                                    {productList[0].images.productPrefix && (
                                        <img
                                            src={
                                                productList[0].images
                                                    .productPrefix
                                            }
                                            alt="coin"
                                        />
                                    )}
                                    {productList[0].quantityDisplay}
                                </Box>
                                {salePercentage > 0 && (
                                    <Box className="stroked">
                                        {productList[0].strokedSaleQuantity}
                                    </Box>
                                )}
                            </Box>
                            <Box
                                className="image"
                                style={{
                                    maxHeight: 60,
                                    flexShrink: 0,
                                    marginTop: 0
                                }}
                            >
                                <img
                                    alt="product"
                                    src={productList[0].images.product}
                                />
                            </Box>
                        </>
                    )}
                </Box>
                {ribbonBadge && (
                    <RibbonBadge
                        text={ribbonBadge.text}
                        textColor={ribbonBadge.textColor}
                        backgroundColor={ribbonBadge.backgroundColor}
                        position={EBadgePosition.CENTER}
                        viewModel={EBundlesInternalViewModel.COMMUNIX}
                    ></RibbonBadge>
                )}
            </Box>

            <BundlePrice
                price={price}
                buttonTextColor={bundleButtonTextColor}
                type={EBundlesInternalViewModel.COMMUNIX}
                buttonColor={bundleButtonColor}
                borderRadius="0 0 9px 9px"
                textShadow="0 0 4px rgba(0,0,0, 0.5)"
                isPreview={inMobileMock}
            />
        </StyledCommunixBundle>
    );
}

export default Bundle;
